module.exports = __webpack_public_path__ + "static/media/20200523-165409-007.97dee68e.png";